import {
  UPDATE_LOADING,
  SHOW_TOAST,
} from '../mutation-types'

const initialState = {
  loading: false,
  toast: {
    show: false,
    type: '',
    content: '',
    size: '9.6em',
    time: 2000,
  },
}

const mutations = {
  [UPDATE_LOADING](state, isLoading) {
    state.loading = isLoading
  },

  [SHOW_TOAST](state, { show = true, type = 'text', content = '', size = '9.6em', time = 2000 }) {
    state.toast.show = show
    state.toast.type = type
    state.toast.content = content
    state.toast.size = size
    state.toast.time = time
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/state.js